import React, { useCallback } from 'react';

import { LifestylesSetUUID } from '../../../lifestylesSetsTypes';
import { ClassName } from '../../../../../types';

import {
  DOWNLOAD_LIFESTYLES_SET_QUERY,
  DownloadLifestylesSetQueryResponse
} from '../../../queries/downloadLifestylesSet.query';

import { useDownloadLifestylesSet } from '../../../../lifestylesSets/hooks/useDownloadLifestylesSet';
import { useDownloadNanoId } from '../../../../downloads/hooks/useDownloadNanoId';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { PureButtonHelper } from '../../../../../helpers/buttons/PureButtonHelper';

import { words } from '../../../../../locales/keys';

interface DownloadLifestylesSetButtonProps {
  className?: ClassName;
  lifestylesSetUuid: LifestylesSetUUID;
}

function DownloadLifestylesSetButton({
  className,
  lifestylesSetUuid
}: DownloadLifestylesSetButtonProps) {
  const { downloadNanoId } = useDownloadNanoId();

  const {
    downloadLifestylesSet,
    downloadLifestylesSetErrorMessage,
    downloadLifestylesSetLoading
  } = useDownloadLifestylesSet<DownloadLifestylesSetQueryResponse>({
    query: DOWNLOAD_LIFESTYLES_SET_QUERY
  });

  useShowToastOnErrorChange({ error: downloadLifestylesSetErrorMessage });

  const handleDownloadLifestylesSet = useCallback<() => void>(
    () =>
      downloadLifestylesSet({
        uuid: lifestylesSetUuid,
        deviceNanoId: downloadNanoId
      }),
    [lifestylesSetUuid, downloadNanoId, downloadLifestylesSet]
  );

  return (
    <PureButtonHelper
      className={
        className ||
        'flex text-left dark:hover:bg-gray-800 hover:bg-gray-100 px-4 py-2 text-sm w-full whitespace-nowrap'
      }
      dataGa="selected-lifestyles-set-download-button"
      i18nText={words.download}
      disabled={downloadLifestylesSetLoading}
      onClick={handleDownloadLifestylesSet}
    />
  );
}

export default DownloadLifestylesSetButton;
